/**
 * @description
 * O default serve para colocar os valores que mais aparecem, para que só precise mudar nos diferentes e diminuir o trabalho braçal.
 * Tome cuidado pois elas serão setadas para todas as opções, você pode mudar manualmente em cada uma para setar diferentes.
 */
const ufsDefaultDefinitions = {
    na: true,
    uf: 'RJ',
    logo: 'logo_nacional.png',
    corPrimaria: '#5c8bb9',
    isIndicadores: false,
    isSala: false,
    isAT: false
}

/**
 * @description
 * Valores referentes a cada tipo de municipio e suas respectivas definições, você deve colocar aqui somente nos caras que são
 * diferentes. Tente usar o ufsDefaultDefinitions para colocar as opções mais comuns entre eles.
 */
const ufsPorDefinitions = [
    //DEV
    { tag: "dev.cidade", ufEmail: 'dev', uf: 'RJ' },
    { tag: "dev.selosaladoempreendedor", ufEmail: 'dev.selosaladoempreendedor', banco: "selo-dev", uf: 'AL', isSala: true, logo: 'logo_sala.png', corPrimaria: '#DAA520' },
    { tag: "dev.agentesterritoriais", ufEmail: 'dev.agentesterritoriais', banco: "at-dev", uf: 'RJ', isSala: false, isAT: true, logo: 'logo_at_branca.png', corPrimaria: '#93CE98' },
    { tag: "sp-dev.", ufEmail: 'sp-dev', uf: 'SP', isIndicadores: true, logo: 'logo_consorcio_branco.png', },
    { tag: "es-dev.", ufEmail: 'es-dev', uf: 'ES' },
    { tag: "ms-dev.", ufEmail: 'ms-dev', uf: 'MS' },
    { tag: "al-dev.", ufEmail: 'al-dev', uf: 'AL' },
    { tag: "ma-dev.", ufEmail: 'ma-dev', uf: 'MA' },
    { tag: "ba-dev.", ufEmail: 'ba-dev', uf: 'BA' },
    { tag: "sc-dev.", ufEmail: 'sc-dev', uf: 'AC' },
    { tag: "ap-dev.", ufEmail: 'ap-dev', uf: 'AP' },
    { tag: "am-dev.", ufEmail: 'am-dev', uf: 'AM' },
    { tag: "ce-dev.", ufEmail: 'ce-dev', uf: 'CE' },
    { tag: "go-dev.", ufEmail: 'go-dev', uf: 'GO' },
    { tag: "mt-dev.", ufEmail: 'mt-dev', uf: 'MT' },
    { tag: "pa-dev.", ufEmail: 'pa-de', uf: 'PA' },
    { tag: "pa-de.", ufEmail: 'pa-de', uf: 'PB' },
    { tag: "pr-dev.", ufEmail: 'pr-dev', uf: 'PR' },
    { tag: "pe-dev.", ufEmail: 'pe-dev', uf: 'PE' },
    { tag: "pi-dev.", ufEmail: 'pi-dev', uf: 'PI' },
    { tag: "rn-dev.", ufEmail: 'rn-dev', uf: 'RN' },
    { tag: "mg-dev.", ufEmail: 'mg-dev', uf: 'MG' },
    { tag: "se-dev.", ufEmail: 'se-dev', uf: 'SE' },
    { tag: "to-dev.", ufEmail: 'to-dev', uf: 'TO' },
    { tag: "df-dev.", ufEmail: 'df-dev', uf: 'DF' },
    { tag: "rj-dev.", ufEmail: 'rj-dev', uf: 'RJ' },
    { tag: "ro-dev.", ufEmail: 'ro-dev', uf: 'RO' },
    { tag: "rr-dev.", ufEmail: 'rr-dev', uf: 'RR' },

    //HLG
    { tag: "hlg.cidade", ufEmail: 'hlg', uf: 'RJ' },
    { tag: "hlg.selosaladoempreendedor", ufEmail: 'hlg.selosaladoempreendedor', banco: "selo-hlg", uf: 'RJ', isSala: true, logo: 'logo_sala.png', corPrimaria: '#DAA520' },
    { tag: "hlg.agentesterritoriais", ufEmail: 'hlg.agentesterritoriais', banco: "at-hlg", uf: 'RJ', isSala: false, isAT: true, logo: 'logo_at_branca.png', corPrimaria: '#93CE98' },
    { tag: "sp-hlg", uf: 'SP', ufEmail: 'sc-hlg', logo: 'logo_consorcio_branco.png', isIndicadores: true },
    { tag: "sc-hlg", ufEmail: 'sc-hlg', uf: 'SC' },
    { tag: "ms-hlg", ufEmail: 'ms-hlg', uf: 'MS' },
    { tag: "al-hlg", ufEmail: 'al-hlg', uf: 'AL' },
    { tag: "ma-hlg", ufEmail: 'ma-hlg', uf: 'MA' },
    { tag: "ap-hlg", ufEmail: 'ap-hlg', uf: 'AP' },
    { tag: "ba-hlg", ufEmail: 'ba-hlg', uf: 'BA' },
    { tag: "rj-hlg", ufEmail: 'rj-hlg', uf: 'RJ' },
    { tag: "ac-hlg", ufEmail: 'ac-hlg', uf: 'AC' },
    { tag: "na-hlg", ufEmail: 'na-hlg', uf: 'NA' },
    { tag: "am-hlg", ufEmail: 'am-hlg', banco: 'ce-am-hlg', uf: 'AM' },
    { tag: "ce-hlg", ufEmail: 'ce-hlg', uf: 'CE' },
    { tag: "es-hlg", ufEmail: 'es-hlg', uf: 'ES' },
    { tag: "go-hlg", ufEmail: 'go-hlg', uf: 'GO' },
    { tag: "mt-hlg", ufEmail: 'mt-hlg', uf: 'MT' },
    { tag: "mg-hlg", ufEmail: 'mg-hlg', uf: 'MG' },
    { tag: "pa-hlg", ufEmail: 'pa-hlg', uf: 'PA' },
    { tag: "pb-hlg", ufEmail: 'pb-hlg', uf: 'PB' },
    { tag: "pr-hlg", ufEmail: 'pr-hlg', uf: 'PR' },
    { tag: "pe-hlg", ufEmail: 'pe-hlg', uf: 'PE' },
    { tag: "pi-hlg", ufEmail: 'pi-hlg', uf: 'PI' },
    { tag: "rn-hlg", ufEmail: 'rn-hlg', uf: 'RN' },
    { tag: "rs-hlg", ufEmail: 'rs-hlg', uf: 'RS' },
    { tag: "ro-hlg", ufEmail: 'ro-hlg', uf: 'RO' },
    { tag: "rr-hlg", ufEmail: 'rr-hlg', banco: "ce-rr-hlg", uf: 'RR' },
    { tag: "se-hlg", ufEmail: 'se-hlg', uf: 'SE' },
    { tag: "to-hlg", ufEmail: 'to-hlg', uf: 'TO' },
    { tag: "df-hlg", ufEmail: 'df-hlg', uf: 'DF' },

    // PROD
    { tag: "ac.", ufEmail: 'ac', banco: "ac", uf: 'AC' },
    { tag: "ms.", ufEmail: 'ms', banco: "ms", uf: 'MS', isIndicadores: false },
    { tag: "al.", ufEmail: 'al', banco: "al", uf: 'AL', isIndicadores: false },
    { tag: "ma.", ufEmail: 'ma', banco: "ma", uf: 'MA', isIndicadores: false },
    { tag: "rj.", ufEmail: 'rj', banco: "rj", uf: 'RJ', isIndicadores: false },
    { tag: "sp.", ufEmail: 'sp', banco: "sp", uf: 'SP', isIndicadores: false, logo: 'logo_consorcio_branco.png' },
    { tag: "es.", ufEmail: 'es', banco: "es", uf: 'ES' },
    { tag: "ba.cidade", ufEmail: 'ba', banco: "ba", uf: 'BA', isIndicadores: false },
    { tag: "sc.", ufEmail: 'sc', banco: "sc", uf: 'SC', isIndicadores: false },
    { tag: "ap.", ufEmail: 'ap', banco: "ap", uf: 'AP' },
    { tag: "am.", ufEmail: 'am', banco: "am", uf: 'AM' },
    { tag: "ce.", ufEmail: 'ce', banco: "ce", uf: 'CE' },
    { tag: "go.", ufEmail: 'go', banco: "go", uf: 'GO' },
    { tag: "mt.", ufEmail: 'mt', banco: "mt", uf: 'MT' },
    { tag: "pa.", ufEmail: 'pa', banco: "pa", uf: 'PA' },
    { tag: "pb.", ufEmail: 'pb', banco: "pb", uf: 'PB' },
    { tag: "pr.", ufEmail: 'pr', banco: "pr", uf: 'PR' },
    { tag: "pe.", ufEmail: 'pe', banco: "pe", uf: 'PE' },
    { tag: "pi.", ufEmail: 'pi', banco: "pi", uf: 'PI' },
    { tag: "rn.", ufEmail: 'rn', banco: "rn", uf: 'RN' },
    { tag: "mg.", ufEmail: 'mg', banco: "mg", uf: 'MG' },
    { tag: "rs.", ufEmail: 'rs', banco: "rs", uf: 'RS' },
    { tag: "ro.", ufEmail: 'ro', banco: "ro", uf: 'RO' },
    { tag: "rr.", ufEmail: 'rr', banco: "rr", uf: 'RR' },
    { tag: "se.", ufEmail: 'se', banco: "se", uf: 'SE' },
    { tag: "to.", ufEmail: 'to', banco: "to", uf: 'TO' },
    { tag: "df.", ufEmail: 'df', banco: "df", uf: 'DF' },
    { tag: "na.", ufEmail: 'na', banco: "na", uf: 'NA' },
    { tag: "na.", ufEmail: 'na', banco: "na", uf: 'NA' },
    { tag: "sc-2022", env: process.env.VUE_APP_BASE_API_SC_2022, ufEmail: 'sc', banco: "cidade-empreendedora-sc-2022", uf: 'SC', logo: 'logo_consorcio_branco.png' },
    { tag: "ma-2022", env: process.env.VUE_APP_BASE_API_MA_2022, ufEmail: 'ma', banco: "cidade-empreendedora-ma-2022", uf: 'MA' },
    { tag: "indicadores-sp", ufEmail: 'sp', banco: "cidade-empreendedora-sp-indicadores", uf: 'SP', logo: 'logo_consorcio_branco.png', isIndicadores: true },
    { tag: "indicadores.consorcioempreendedor", ufEmail: 'indicadores.consorcioempreendedor', banco: "sp", uf: 'SP', logo: 'logo_consorcio_branco.png' },
    { tag: "rj.selosaladoempreendedor", ufEmail: 'rj.selosaladoempreendedor', banco: "selo-sala-rj", uf: 'RJ', isSala: true, logo: 'logo_sala.png', corPrimaria: '#DAA520' },
    { tag: "al.selosaladoempreendedor", ufEmail: 'al.selosaladoempreendedor', banco: "selo-sala-al", uf: 'AL', isSala: true, logo: 'logo_sala.png', corPrimaria: '#DAA520' },
    { tag: "rj.agentesterritoriais", ufEmail: 'rj', banco: "agentes-territoriais-rj", uf: 'RJ', isAT: true, logo: 'logo_at_branca.png', corPrimaria: '#93CE98' },
    { tag: "localhost", ufEmail: 'dev', banco: "ce-hlg", uf: 'RJ' }

];

const ufsDefinitions = ufsPorDefinitions.map(item => { return ({ ...ufsDefaultDefinitions, ...item }) })


let atual
let hrf = window.location.href
const ceDevBanco = 'ce-dev';
const ceHlgBanco = 'ce-hlg'


ufsDefinitions.forEach(item => {
    if (hrf.includes(item.tag)) {
        // urls com dev no nome
        if (item.tag.indexOf('dev') !== -1) {
            if (!item.banco) {
                item.banco = ceDevBanco
            }
            item.env = process.env.VUE_APP_BASE_API_DEV
        }
        // urls com hlg no nome
        else if (item.tag.indexOf('hlg') !== -1) {

            if (!item.banco) {
                item.banco = ceHlgBanco
            }
            item.env = process.env.VUE_APP_BASE_API_HLG
            // urls com localhost no nome
        } else if (item.tag.indexOf('localhost') !== -1) {
            if (!item.banco) {
                item.banco = ceDevBanco
            }
            item.env = process.env.VUE_APP_BASE_API_LOCAL
        }
        // produção
        else {
            if (!item.env) {
                item.env = process.env.VUE_APP_BASE_API_PROD
            }
        }
        atual = { ...item, urlTag: item.tag };
    }
});

export const atualUfDefinition = atual



/**
 *
 * @param {*} str - Essa string já vem automatica no filtro, não precisa passar
 * @param {*} tipo - cpf | telefone | email | nome
 * @returns
 */
export const esconderPalavras = (str, tipo) => {
    if (str) {
        if (tipo === "cpf") {
            return str.substring(0, 4) + "**" + str.substring(11, 14);
        } else if (tipo === "telefone") {
            return str.substring(0, 4) + "**" + str.substring(8, 11);
        } else if (tipo === "email") {
            let indexOfArroba = str.indexOf("@", 0);
            let indexOfArrobaDivided = parseInt(str.indexOf("@", 0) / 2);
            return (
                str.substring(0, indexOfArrobaDivided) +
                "**" +
                str.substring(indexOfArroba)
            );
        } else if (tipo === "nome") {
            let names = str.split(" ");
            return names[0] + " " + names[names.length - 1];
        }
    }
    return str;
};

export const sortArrayAsc = (a, b) => {
    if (a > b) return +1;
    if (a < b) return -1;
    return 0;
}
